/**
 * @ComponentFor BlockSliderBlockViewModel
 */

import connect from 'Shared/connect';
import React, { useState } from 'react';
import { isCompact as functionIsCompact } from 'Shared/Viewport';
import { styled } from '@glitz/react';
import BlockSliderBlockViewModel from './BlockSliderBlockViewModel.type';
import QuickShopProductModal from 'Shared/QuickShopProductModal';
import ProductListItemViewModel from 'Product/ProductListing/ProductListItemViewModel.type';
import { epiPropertyValue } from '@polarnopyret/scope-episerver';
import { resolveSyncIfLoadedOrThrow } from '@polarnopyret/scope/index';
import SwiperList from 'Shared/SwiperList';
import { GridWrap } from 'Shared/PageLayout';
import { createGridClasses, createOffsetGridClassLarge } from 'Shared/grid';
import * as style from 'Shared/Style';

const ShopTheLookComponent = "Avensia.Common.Features.Shared.Blocks.ShopTheLook.ShopTheLookItemBlockViewModel";

const Wrap = styled(GridWrap, {
  padding: {
    y: '80px',
  },
  ['@media ' + style.mediaMinLarge]: {
    padding: {
      y: '120px',
    },
  },
})

export const BlockSliderBlock = connect(
  state => ({
    currentBreakpoint: state.currentBreakpoint,
  })
)((props: BlockSliderBlockViewModel & { currentBreakpoint: number }) => {
  
  const { currentBreakpoint } = props;
  const isMobile = functionIsCompact(currentBreakpoint);
  const contentArea = epiPropertyValue(props.currentBlock.items);
  const [modalData, setModalData] = useState<{ showModal: boolean, products: ProductListItemViewModel[] }>({showModal: false, products: []});
  
  const itemComponent = (item: Scope.ContentAreaItem) => {
    const ItemComponent = resolveSyncIfLoadedOrThrow(item.componentName);
    
    if (item.componentName === ShopTheLookComponent) {
      return <ItemComponent setModalData={setModalData} {...item}/>;
    }
    else {
      return <ItemComponent {...item} />;
    }
  }

  return (
    <Wrap className='grid wsb'>
      <div className={createGridClasses(12, 11, createOffsetGridClassLarge(2))}>
        <div>
          <SwiperList
            slidesPerView={isMobile ? 1.2 : 2.75}
            slidesPerGroup={isMobile ? 1 : 2}
            spaceBetween={isMobile ? 8 : 16}
            isCompact={isMobile}
            showNav={!isMobile}
            alternativeNav={true}
            listHeading={epiPropertyValue(props.currentBlock.heading)}
            cssMode={true}
            showSwirl={isMobile}
          >
            {contentArea && contentArea.items.map((item, index) => {
              return <div key={index} className="swiper-slide">
                {itemComponent(item)}
              </div>;
            })}
          </SwiperList>
          <QuickShopProductModal isMobile={isMobile} modalIsShown={modalData.showModal} hideModal={() => setModalData({showModal: false, products: []})} products={modalData.products} />
        </div>
      </div>
    </Wrap>
  );
});

export default BlockSliderBlock;
